if (!customElements.get('faq-search')) {
  customElements.define('faq-search', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-faq-root]');
      this.input = this.querySelector('[data-faq-search]');
      this.categories = this.root?.querySelector('[data-faq-categories]');
      this.topics = this.root?.querySelector('[data-faq-topics]');
      this.explorer = this.root?.querySelector('[data-faq-explorer]');
      this.moreButton = this.root?.querySelector('[data-faq-more]');
      if (!this.root || !this.input || !this.categories) return;

      this.relocateCategories();
      this.onInput = () => this.filter();
      this.onTopic = (event) => {
        const link = event.target.closest('[data-faq-topic]');
        if (!link) return;
        this.input.value = '';
        this.filter();
        this.setActiveTopic(link.getAttribute('href')?.slice(1));
      };
      this.onMore = () => {
        this.explorer.classList.add('is-revealed');
        this.moreButton.hidden = true;
        this.input.focus();
      };
      this.onSectionLoad = () => {
        this.relocateCategories();
        this.filter();
        this.observeTopics();
      };
      this.onBlockSelect = (event) => {
        const question = event.target.closest('[data-faq-category] .faq-question');
        if (!question) return;
        this.input.value = '';
        this.filter();
        question.open = true;
      };

      this.input.addEventListener('input', this.onInput);
      this.root.addEventListener('click', this.onTopic);
      this.moreButton?.addEventListener('click', this.onMore);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.observeTopics();
      this.hidden = false;
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.onInput);
      this.root?.removeEventListener('click', this.onTopic);
      this.moreButton?.removeEventListener('click', this.onMore);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.topicObserver?.disconnect();
    }

    relocateCategories() {
      document.querySelectorAll('[data-faq-category]').forEach((category) => {
        if (category.parentElement !== this.categories) this.categories.append(category);
      });
    }

    setActiveTopic(categoryId) {
      if (!categoryId) return;
      this.topics?.querySelectorAll('[data-faq-topic]').forEach((topic) => {
        topic.classList.toggle('is-active', topic.getAttribute('href') === `#${categoryId}`);
      });
    }

    observeTopics() {
      this.topicObserver?.disconnect();
      if (!this.topics) return;
      this.topicObserver = new IntersectionObserver((entries) => {
        const activeEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (activeEntry) this.setActiveTopic(activeEntry.target.id);
      }, { rootMargin: '-18% 0px -68% 0px' });
      this.categories.querySelectorAll('[data-faq-category]').forEach((category) => this.topicObserver.observe(category));
    }

    filter() {
      const terms = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let matches = 0;
      this.categories.querySelectorAll('[data-faq-category]').forEach((category) => {
        let categoryMatches = 0;
        category.querySelectorAll('.faq-question').forEach((question) => {
          const match = terms.every((term) => question.textContent.toLocaleLowerCase().includes(term));
          question.hidden = !match;
          question.open = terms.length > 0 && match;
          if (match) categoryMatches++;
        });
        category.hidden = categoryMatches === 0;
        matches += categoryMatches;
      });

      this.querySelector('[data-faq-status]').textContent = terms.length
        ? `${matches} ${matches === 1 ? 'answer' : 'answers'} found`
        : '';
      this.querySelector('[data-faq-empty]').hidden = !terms.length || matches > 0;
      this.topics?.classList.toggle('is-searching', terms.length > 0 && matches > 0);
    }
  });
}
